// extracted by mini-css-extract-plugin
module.exports = {"primaryBtn":"Button_primaryBtn__3jXl7","secondaryBtn":"Button_secondaryBtn__3BxUT"};